howspace.workspace.settings = (() => {
    'use strict';

    return {
        initEmailDeliverySchedule: () => {
            const scheduleTime = $('#workspace-configuration-whatsnew-email-sending-schedule-time');
            const schedule = scheduleTime.data('schedule');
            const scheduleWeekday = $('#workspace-configuration-whatsnew-email-sending-schedule-weekday');
            if (schedule) {
                let time = schedule.substring(schedule.length - 5);
                time = howspace.components.time.getBrowserTime(time);
                scheduleTime.val(time);
            } else {
                scheduleTime.val('00.00');
                scheduleWeekday.val('friday');
            }

            $('#workspace-configuration-whatsnew-email-sending-policy').on('change', function () {
                const weekDaySelectWrapper = $('.workspace-configuration-whatsnew-email-sending-schedule-weekday-wrapper');
                const hiddenScheduleWrapper = $('.workspace-configuration-whatsnew-email-sending-schedule-wrapper:hidden');
                const visibleScheduleWrapper = $('.workspace-configuration-whatsnew-email-sending-schedule-wrapper:visible');

                switch ($(this).val()) {
                    case 'daily':
                        weekDaySelectWrapper.removeClass('d-flex').addClass('d-none');
                        hiddenScheduleWrapper.velocity('slideDown', 'fast');
                        break;

                    case 'weekly':
                        weekDaySelectWrapper.removeClass('d-none').addClass('d-flex');
                        hiddenScheduleWrapper.velocity('slideDown', 'fast');
                        break;

                    default:
                        visibleScheduleWrapper.velocity('slideUp', 'fast');
                        break;
                }
            });
        },

        getEmailDeliverySchedule: () => {
            const scheduleWeekday = $('#workspace-configuration-whatsnew-email-sending-schedule-weekday').val();
            let scheduleTime = $('#workspace-configuration-whatsnew-email-sending-schedule-time').val() || '';
            if (scheduleTime !== '') {
                scheduleTime = howspace.components.time.getUtcTime(scheduleTime);
            }

            switch ($('#workspace-configuration-whatsnew-email-sending-policy').val()) {
                case 'daily':
                    return 'today ' + scheduleTime;

                case 'weekly':
                    return scheduleWeekday + ' this week ' + scheduleTime;

                default:
                    return null;
            }
        },

        getUseCases: (modal) => {
            let result = [];
            modal.find('.use-cases-checkbox:checked').each(function() {
                result.push($(this).val());
            });
            return result;
        },

        getTwoFactorAuthenticationSettings: (modal, securitySettings) => {
            const twoFactorAuthRadio = modal.find('input[name="loginlink_2fa"]:checked');
            const twoFactorAuthType = twoFactorAuthRadio.val();
            const twoFactorAuthMethodRadio = modal.find('input[name="loginlink_2fa_method_' + twoFactorAuthType + '"]:checked');

            const settingsKey = securitySettings.default_workspace_security_settings
                ? 'default_workspace_security_settings'
                : 'security_settings';

            const updateSecuritySettings = (emailRequired, smsRequired, alwaysRequire) => {
                securitySettings[settingsKey].require_email_verification_when_using_loginlink_with_new_device = emailRequired;
                securitySettings[settingsKey].require_sms_verification_when_using_loginlink_with_new_device = smsRequired;
                securitySettings[settingsKey].require_verification_always_when_using_loginlink = alwaysRequire;
            };

            switch (twoFactorAuthType) {
                case 'disabled':
                    updateSecuritySettings(false, false, false);
                    break;
                case 'new_devices_only':
                case 'always_on':
                    const isAlwaysOn = twoFactorAuthType === 'always_on';
                    updateSecuritySettings(twoFactorAuthMethodRadio.val() === 'email', twoFactorAuthMethodRadio.val() === 'sms', isAlwaysOn);
                    break;
            }

            // Disable 2FA if login links are not enabled.
            if (securitySettings[settingsKey]?.is_login_links_enabled === false) {
                updateSecuritySettings(false, false, false);
            }
        },

        getCustomLinks: (dataPayload, isDefaultSettings) => {
            const paramName = isDefaultSettings
                ? 'default_custom_links'
                : 'custom_links';

            let error = false;

            dataPayload[paramName] = [];

            $('.custom-link:not(.deleted)').each(function () {
                const link = $(this);
                const title = link.find('input[name="title"]');
                const href = link.find('input[name="href"]');
                const linkDataPayload = real.form.getDataPayload(link);
                if (linkDataPayload.title === '') {
                    error = true;
                    howspace.form.markInvalidField(title);
                }
                if (linkDataPayload.href === '') {
                    error = true;
                    howspace.form.markInvalidField(href);
                } else if (!linkDataPayload.href.toLowerCase().startsWith('https://')) {
                    error = true;
                    href.siblings('.invalid-feedback').text(howspace.translate('workspacesettings_custom_link_protocol'));
                    howspace.form.markInvalidField(href);
                }

                if (!error) {
                    dataPayload[paramName].push(linkDataPayload);
                }
            });

            return !error;
        },

        getPrivacySettings: (dataPayload, isDefaultSettings) => {
            const paramName = isDefaultSettings
                ? 'default_workspace_privacy_settings'
                : 'privacy_settings';

            if (!dataPayload[paramName]) {
                dataPayload[paramName] = {};
            }
            if (!dataPayload[paramName].delete_inactive_users_after_days) {
                dataPayload[paramName].delete_inactive_users_after_days = 0;
            }
            if (!dataPayload[paramName].anonymize_deleted_users_after_days) {
                dataPayload[paramName].anonymize_deleted_users_after_days = 0;
            }
        },

        getSecuritySettings: (dataPayload, isDefaultSettings) => {
            const paramName = isDefaultSettings
                ? 'default_workspace_security_settings'
                : 'security_settings';

            if (!dataPayload[paramName]) {
                dataPayload[paramName] = {};
            }

            if ($('input[value="multi_tenant_sso"]').prop('checked')) {
                dataPayload[paramName].sso_entity_id = '';
            } else {
                dataPayload[paramName].sso_entity_ids = [];
            }

            if (!dataPayload[paramName].ip_filters) {
                dataPayload[paramName].ip_filters = [];
            }
        },

        getSettingsPayload: (main, isDefaultSettings) => {
            const dataPayload = real.form.getDataPayload(main);

            if (!howspace.workspace.settings.getCustomLinks(dataPayload, isDefaultSettings)) {
                return null;
            }

            howspace.workspace.settings.getSecuritySettings(dataPayload, isDefaultSettings);
            howspace.workspace.settings.getTwoFactorAuthenticationSettings(main, dataPayload);

            howspace.workspace.settings.getPrivacySettings(dataPayload, isDefaultSettings);

            const genericWhatsNewSelect = main.find('.generic-whats-new-select');
            if (genericWhatsNewSelect.length) {
                const paramName = genericWhatsNewSelect.data('features-param-name');
                if (paramName) {
                    if (!Array.isArray(dataPayload[paramName])) {
                        dataPayload[paramName] = [];
                    }

                    switch (genericWhatsNewSelect.val()) {
                        case 'everybody':
                            dataPayload[paramName].push('whatsnew_for_all');
                            dataPayload[paramName].push('whatsnew_for_admin');
                            break;
                        case 'admins':
                            dataPayload[paramName].push('whatsnew_for_admin');
                            break;
                    }
                }
            }

            return dataPayload;
        },

        attachCustomLinkHandlers: () => {
            const customLinks = $('.custom-links');

            $('.add-custom-link-btn').on('click', () => {
                howspace.components.sortableList.addItem(customLinks);

                if (howspace.accountManager !== undefined) {
                    howspace.accountManager.setModified();
                } else {
                    howspace.manager.setModified();
                }
            });

            real.dom.$body.on('click', '.custom-link .delete-btn', () => {
                if (howspace.accountManager !== undefined) {
                    howspace.accountManager.setModified();
                } else {
                    howspace.manager.setModified();
                }
            });

            customLinks.on('input', 'input[required]', e => {
                const input = $(e.currentTarget);
                if (input.val().trim() !== '') {
                    howspace.form.clearInvalidField(input);
                } else {
                    howspace.form.markInvalidField(input, howspace.translate('common_required'));
                }
            });
        },

        attachAuthenticationMethodHandlers: (modal) => {
            $('.anonymous-login-btn').on('change', e => {
                const checkbox = $(e.target);
                const collapse = $('#workspace-anonymous-login-config-container');

                if (!checkbox.prop('checked')) {
                    // Changing checkbox from checked to unchecked. This is fine.
                    howspace.components.collapse.close(collapse);
                    return;
                }

                // Uncheck the checkbox.
                checkbox.prop('checked', false);

                // Open translation confirm modal.
                if (!modal) {
                    howspace.components.modal.show(real.baseUri + '/manager/settings/confirm-anonymous-login-modal', confirmModal => {
                        $(confirmModal).find('.confirm-btn').on('click', function () {
                            checkbox.prop('checked', true);
                            howspace.components.collapse.open(collapse);
                        });
                    });
                } else {
                    checkbox.prop('checked', true);
                    howspace.components.collapse.open(collapse);
                }
            });
        },

        attachLoginHandlers: (modal) => {
            const isSsoEnabledToggle = modal.find('#security-settings-is-sso-enabled');
            const isSocialLoginEnabledToggle = modal.find('#security-settings-is-social-login-enabled');

            isSsoEnabledToggle.on('change', function () {
                if ($(this).is(':checked') && isSocialLoginEnabledToggle.is(':checked')) {
                    isSocialLoginEnabledToggle.trigger('click');
                }
            });

            isSocialLoginEnabledToggle.on('change', function () {
                if ($(this).is(':checked') && isSsoEnabledToggle.is(':checked')) {
                    isSsoEnabledToggle.trigger('click');
                }
            });

            const ssoEntityIdCheckboxesWrapper = modal.find('.sso-entity-id-checkboxes-wrapper');
            const ssoEntityIdSelectWrapper = modal.find('.sso-entity-id-select-wrapper');

            modal.find('input[value="multi_tenant_sso"]').on('change', (e) => {
                const checkbox = $(e.currentTarget);
                if (checkbox.prop('checked')) {
                    // allow multiple selections, show checkboxes, hide select
                    ssoEntityIdCheckboxesWrapper.removeClass('d-none');
                    ssoEntityIdSelectWrapper.addClass('d-none');
                } else {
                    // only single selection allowed, show select, hide checkboxes
                    ssoEntityIdCheckboxesWrapper.addClass('d-none');
                    ssoEntityIdSelectWrapper.removeClass('d-none');
                }
            });
        },

        initImmediateEmailToggle: (wrapper) => {
            wrapper.find('.immediate-email-checkbox').on('change', function () {
                wrapper.find('.immediate-email-yes-no').text(
                    $(this).is(':checked') ? howspace.translate('common_yes') : howspace.translate('common_no')
                );
            });
        }
    };
})();
